import script from "./ReportDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportDownload.vue?vue&type=script&setup=true&lang=ts"

import "./ReportDownload.vue?vue&type=style&index=0&id=051ba0a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051ba0a2"]])

export default __exports__